/**
 * Cliente API Base
 * Configuração centralizada do axios com interceptadores
 */
import axios from "axios";

// URL base da API - usa variável de ambiente ou fallback para desenvolvimento
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8080" || "http://localhost:8080";
// Cria instância do axios
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000, // 30 segundos
});

// Interceptor de requisição - adiciona token automaticamente
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error("[API] Erro no interceptor de requisição:", error);
    return Promise.reject(error);
  }
);

// Interceptor de resposta - trata erros e refresh token
apiClient.interceptors.response.use(
  (response) => {
    // Retorna apenas os dados da resposta
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;

    // Se o erro for 401 e não for uma tentativa de refresh
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/auth/login") &&
      !originalRequest.url.includes("/auth/refresh")
    ) {
      originalRequest._retry = true;

      try {
        // Tentar renovar o token
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken) {
          
          const response = await axios.post(
            `${API_BASE_URL}/api/auth/refresh`,
            {},
            {
              headers: {
                Authorization: `Bearer ${refreshToken}`,
              },
            }
          );

          const { access_token } = response.data;
          if (access_token) {
            localStorage.setItem("accessToken", access_token);
            originalRequest.headers.Authorization = `Bearer ${access_token}`;
            return apiClient(originalRequest);
          }
        }
      } catch (refreshError) {
        console.error("[API] Erro ao renovar token:", refreshError);
        // Limpa tokens e redireciona para login
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("loggedUser");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    // Formata mensagem de erro
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Erro desconhecido";

    console.error("[API] Erro na requisição:", {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: errorMessage,
    });

    // Rejeita com mensagem formatada
    return Promise.reject(new Error(errorMessage));
  }
);

export default apiClient;

